// Module
var code = "<template> <section class=\"question-date-element\"> <div class=\"row ess-wrap\"> <div class=\"col s12 m3\"> <ess-date value.bind=\"selectedDate\" labelledby-id.bind=\"labelId\" readonly.bind=\"readonly\" value-changed.delegate=\"handleValueChanged()\"></ess-date> </div> </div> </section> </template> ";
// Exports
module.exports = code;